export const getServiceProviderProfilePath = (providerId: string): string =>
  `/service-provider/${providerId}`;
